<script lang="ts" setup>
import { useI18n } from "vue-i18n";
import CopyButton from "@/components/buttons/CopyButton.vue";
import type { OrderRefs } from "@/types/props";

const props = defineProps<{
  orders: OrderRefs[];
}>();

const { t } = useI18n();
</script>

<template>
  <div class="bg-grey-lighten-4 w-100 rounded border-grey-lighter pa-3 d-flex row-gap-2 flex-column">
    <div v-for="(order, orderIndex) in props.orders" :key="orderIndex" class="d-flex aligin-items-center col-gap-3">
      <copy-button v-if="order.number" :text="`${order.number}`" class="mr-1">
        <span class="text-primary font-weight-500">Order #{{ order.number }}</span>
      </copy-button>

      <span class="text-uppercase text-grey-darken-1 font-weight-600">{{ t("general.ref") }}:</span>

      <copy-button v-for="(ref, index) in order.refNumbers" :key="index" :text="ref">
        <span>#{{ ref }}</span>
      </copy-button>
    </div>
  </div>
</template>
